// extracted by mini-css-extract-plugin
export var drinksHolder = "pageElements-module--drinksHolder--6698a";
export var hollieHolder = "pageElements-module--hollieHolder--ebb25";
export var leftLeaves = "pageElements-module--leftLeaves--d6898";
export var pageBackground = "pageElements-module--pageBackground--fc731";
export var rightLeaves = "pageElements-module--rightLeaves--e91a0";
export var roomHolder = "pageElements-module--roomHolder--d0d16";
export var sceneHolder = "pageElements-module--sceneHolder--1c8c7";
export var sceneInner = "pageElements-module--sceneInner--de420";